"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _analytics = require("./analytics");
Object.keys(_analytics).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _analytics[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _analytics[key];
    }
  });
});
var _app = require("./app");
Object.keys(_app).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _app[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _app[key];
    }
  });
});
var _defaultTranslations = require("./defaultTranslations");
Object.keys(_defaultTranslations).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _defaultTranslations[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _defaultTranslations[key];
    }
  });
});
var _defaultTranslationsWithNamespaces = require("./defaultTranslationsWithNamespaces");
Object.keys(_defaultTranslationsWithNamespaces).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _defaultTranslationsWithNamespaces[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _defaultTranslationsWithNamespaces[key];
    }
  });
});
var _feature = require("./feature");
Object.keys(_feature).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _feature[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _feature[key];
    }
  });
});
var _parameters = require("./parameters");
Object.keys(_parameters).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _parameters[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _parameters[key];
    }
  });
});
var _settings = require("./settings");
Object.keys(_settings).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _settings[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _settings[key];
    }
  });
});
var _tenants = require("./tenants");
Object.keys(_tenants).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _tenants[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _tenants[key];
    }
  });
});
var _topAreaNavigation = require("./topAreaNavigation");
Object.keys(_topAreaNavigation).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _topAreaNavigation[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _topAreaNavigation[key];
    }
  });
});